import {
  CONTACT_OTP_GENERATE_REQUEST,
  CONTACT_OTP_GENERATE_SUCCESS,
  CONTACT_OTP_GENERATE_FAILURE,
  CONTACT_OTP_VALIDATE_REQUEST,
  CONTACT_OTP_VALIDATE_SUCCESS,
  CONTACT_OTP_VALIDATE_FAILURE,
  CONTACT_OTP_RESET,
} from "../actions/actionTypes";
import apiClient from "../../utils/apiClient";

/** Normalize Ethiopian phone numbers to 09xxxxxxxx for the OTP service. */
export function normalizePhoneForOtp(phone) {
  const digits = String(phone || "").replace(/\D/g, "");
  if (digits.startsWith("251") && digits.length >= 12) {
    return `0${digits.slice(3)}`;
  }
  if (digits.startsWith("0")) return digits;
  if (digits.length === 9) return `0${digits}`;
  return digits;
}

function contactTarget(channel, value) {
  return channel === "phone"
    ? normalizePhoneForOtp(value)
    : String(value).trim();
}

function extractErrorMessage(error, fallback) {
  const data = error.response?.data;
  if (typeof data?.message === "string") return data.message;
  if (typeof data?.message?.message === "string") return data.message.message;
  return error.message || fallback;
}



export const resetContactOtp = () => ({ type: CONTACT_OTP_RESET });

/** Generate OTP via middleware: POST /contactOtp/sendOTP */
export const generateContactOtpThunk = (channel, value) => {
  return async (dispatch) => {
    dispatch({ type: CONTACT_OTP_GENERATE_REQUEST, payload: { channel } });
    try {
      const response = await apiClient.post("/contactOtp/sendOTP", {
        individualId: contactTarget(channel, value),
        channel,
      });

      if (response.data?.success === false) {
        throw new Error(response.data?.message || "Failed to send OTP");
      }

      const transactionId = response.data[0].transactionId;

      if (!transactionId) {
        throw new Error("OTP sent but transactionId was missing from response");
      }

      dispatch({
        type: CONTACT_OTP_GENERATE_SUCCESS,
        payload: { channel, transactionId },
      });
      return transactionId;
    } catch (error) {
      dispatch({
        type: CONTACT_OTP_GENERATE_FAILURE,
        payload: {
          channel,
          message: extractErrorMessage(error, "Failed to send OTP"),
        },
      });
      return null;
    }
  };
};

/** Validate OTP via middleware: POST /contactOtp/validateOTP */
export const validateContactOtpThunk =
  (channel, value, otp, transactionId) => {
    return async (dispatch) => {
      dispatch({
        type: CONTACT_OTP_VALIDATE_REQUEST,
        payload: { channel },
      });

      try {
        if (!transactionId) {
          throw new Error(
            "Missing transactionId. Please resend the OTP."
          );
        }

        const response = await apiClient.post(
          "/contactOtp/validateOTP",
          {
            transactionId,
            individualId: contactTarget(channel, value),
            otp,
          }
        );

        console.log(
          "OTP validation response:",
          response.data
        );

        // API returns an array
        const result = response.data?.[0];

        // OTP is invalid
        if (
          result?.status === "FAILURE" ||
          result?.statusCode >= 400
        ) {
          throw new Error(
            result?.message || "Invalid OTP"
          );
        }

        // OTP is valid
        dispatch({
          type: CONTACT_OTP_VALIDATE_SUCCESS,
          payload: { channel },
        });

        return true;

      } catch (error) {
        const responseData = error?.response?.data?.[0];

        const message =
          responseData?.status === "FAILURE"
            ? "Invalid OTP"
            : extractErrorMessage(
                error,
                "Invalid OTP, please try again"
              );

        dispatch({
          type: CONTACT_OTP_VALIDATE_FAILURE,
          payload: {
            channel,
            message,
          },
        });

        return false;
      }
    };
  };